import * as THREE from 'three';
import { CHUNK_SIZE, CHUNK_SIZE_SQ, CHUNK_SIZE_CU } from '../constants.js';

export class Chunk {
  constructor(cx, cy, cz) {
    this.cx = cx;
    this.cy = cy;
    this.cz = cz;
    this.blocks = new Uint8Array(CHUNK_SIZE_CU);
    this.lightMap = null; // Uint8Array(CHUNK_SIZE_CU), populated by LightEngine
    this.mesh = null;
    this.transparentMesh = null;
    this.isDirty = true;
    // Track non-air block count for empty chunk optimization
    this.nonAirCount = 0;
    // Cache the world-space bounding box for frustum culling
    this.boundingBox = new THREE.Box3(
      new THREE.Vector3(cx * CHUNK_SIZE, cy * CHUNK_SIZE, cz * CHUNK_SIZE),
      new THREE.Vector3((cx + 1) * CHUNK_SIZE, (cy + 1) * CHUNK_SIZE, (cz + 1) * CHUNK_SIZE)
    );
  }

  static index(x, y, z) {
    return x + y * CHUNK_SIZE + z * CHUNK_SIZE_SQ;
  }

  getBlock(x, y, z) {
    return this.blocks[Chunk.index(x, y, z)];
  }

  setBlock(x, y, z, blockId) {
    const idx = Chunk.index(x, y, z);
    const old = this.blocks[idx];
    if (old === blockId) return; // No change, skip marking dirty
    // Update non-air count
    if (old === 0 && blockId !== 0) this.nonAirCount++;
    else if (old !== 0 && blockId === 0) this.nonAirCount--;
    this.blocks[idx] = blockId;
    this.isDirty = true;
  }

  /** Returns true if the chunk contains no non-air blocks */
  isEmpty() {
    return this.nonAirCount === 0;
  }

  dispose() {
    if (this.mesh) {
      this.mesh.geometry.dispose();
      this.mesh = null;
    }
    if (this.transparentMesh) {
      this.transparentMesh.geometry.dispose();
      this.transparentMesh = null;
    }
  }
}
